// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".single-payway p{font-size:.9rem;line-height:1.2;text-align:center;text-transform:uppercase;font-family:Lato Bold,Helvetica,Arial,sans-serif}@media(min-width:992px){.single-payway p{padding:0 10px;font-size:1rem}}", ""]);
// Exports
module.exports = exports;
